<template>
	<v-modal class="v-modal--switch-to-phone">
		<template v-slot:header>
			<h1 class="alpha">Switch To Phone</h1>
		</template>
		<div class="editorial center">
			<p class="alpha highlight-text">We suggest you complete your ID check on your phone.</p>
			<p class="beta">Simply scan this QR code for instant access.</p>
		</div>
		<img
			:src="'data:image/svg+xml;base64,' + $authed().idCheck.qrCode"/>
		<template v-slot:footer>
			<ul class="actions actions--right">
				<li>
					<button
						class="button button--text"
						@click.prevent="$vmodal.close()">Not Now
					</button>
				</li>
				<li>
					<button
						class="button button--primary"
						@click.prevent="continueOnDesktop()">Continue On Desktop
					</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	methods: {
		continueOnDesktop() {
			window.open(this.$authed().idCheck.link);
		},
	},
};
</script>
